import React from "react";
import { styled } from "@mui/material/styles";
import {
  CardContact,
  Card6,
  CardTitle,
  GeneralAccordionCard,
} from "../other/card";
import Box from "@mui/material/Box";
import { convertDateTimeToDate } from "../../js/stringHandling";
import "../../styles/side-panel.css";
import { Link, Events, animateScroll } from "react-scroll";
import { CssDataJacketBodyTypography } from "../../styles/styled";

const CssBox = styled(Box)({
  maxWidth: "1300px",
  paddingLeft: "16px",
});

const CssLink = styled(Link)({
  color: "white",
  marginLeft: "10px",
  marginBottom: "6px",
  fontSize: "14px",
  "&:hover": {
    backgroundColor: "#75787b",
    cursor: "pointer",
  },
});
const CssLinkTitle = styled(Link)({
  color: "white",
  fontSize: "16px",
  fontWeight: "bold",
  "&:hover": {
    backgroundColor: "#75787b",
    cursor: "pointer",
  },
});

export default function DataJacketTabDetail({
  dataJacket,
  dataSetIds,
  termOfUse,
  policy,
  price,
  protection,
  scroll,
}) {
  const [offset, setOffset] = React.useState(0);

  function scrollByOffset() {
    Events.scrollEvent.register("end", function (to, element) {
      setOffset(-160);
      if (offset === 0) {
        if (element.id === "データジャケット情報") {
          animateScroll.scrollMore(-170);
        } else if (element.id !== "データに関する問い合わせ先") {
          animateScroll.scrollMore(-80);
        }
      }
    });
  }
  React.useEffect(() => {
    try {
      if (scroll === true && (offset === 0 || offset === "")) {
        setOffset(-160);
      } else if (scroll === false) {
        setOffset(-100);
      }
    } catch (e) {}
  }, [scroll]);

  React.useEffect(() => {
    try {
      if (offset !== 0 || offset !== "") {
        Events.scrollEvent.remove("end");
      }
    } catch (e) {}
  }, [offset]);

  return (
    <span>
      <div
        style={{
          width: "100%",
        }}
      >
        <Box
          style={{
            position: "fixed",
            zIndex: "10",
            backgroundColor: "#505458",
            width: "250px",
            right: "0",
            top: "300px",
          }}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "column ",
              padding: "10px",
            }}
          >
            <CssLinkTitle
              activeClass="clsLinkActive"
              smooth
              spy
              to="データジャケット情報"
              offset={offset}
              onClick={scrollByOffset}
            >
              データジャケット情報
            </CssLinkTitle>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="データの収集方法"
              onClick={scrollByOffset}
              offset={offset}
            >
              データの収集方法
            </CssLink>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="データセットの分析方法・ケースおよび結果概要"
              onClick={scrollByOffset}
              offset={offset}
            >
              データセットの分析方法・ケースおよび結果概要
            </CssLink>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="自由記述"
              onClick={scrollByOffset}
              offset={offset}
            >
              自由記述
            </CssLink>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="データジャケットのライセンス"
              onClick={scrollByOffset}
              offset={offset}
            >
              データジャケットのライセンス
            </CssLink>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="データジャケットの権利表明"
              onClick={scrollByOffset}
              offset={offset}
            >
              データジャケットの権利表明
            </CssLink>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="データジャケットの公開等に関する情報"
              onClick={scrollByOffset}
              offset={offset}
            >
              データジャケットの公開等に関する情報
            </CssLink>
            <CssLinkTitle
              activeClass="clsLinkActive"
              smooth
              spy
              to="データセット情報"
              onClick={scrollByOffset}
              offset={offset}
            >
              データセット情報
            </CssLinkTitle>
            {dataSetIds.ids !== "" && (
              <CssLink
                activeClass="clsLinkActive"
                smooth
                spy
                to="データセットのタイトル"
                onClick={scrollByOffset}
                offset={offset}
              >
                データセットのタイトル
              </CssLink>
            )}
            {dataSetIds.ids !== "" && (
              <CssLink
                activeClass="clsLinkActive"
                smooth
                spy
                to="データセットの説明"
                onClick={scrollByOffset}
                offset={offset}
              >
                データセットの説明
              </CssLink>
            )}
            {dataSetIds.ids !== "" && (
              <CssLink
                activeClass="clsLinkActive"
                smooth
                spy
                to="データコンテンツ・項目説明"
                onClick={scrollByOffset}
                offset={offset}
              >
                データコンテンツ・項目説明
              </CssLink>
            )}
            {dataSetIds.ids !== "" && (
              <CssLink
                activeClass="clsLinkActive"
                smooth
                spy
                to="データコンテンツの補足情報"
                onClick={scrollByOffset}
                offset={offset}
              >
                データコンテンツの補足情報
              </CssLink>
            )}
            {dataSetIds.ids !== "" && (
              <CssLink
                activeClass="clsLinkActive"
                smooth
                spy
                to="データセットの対象期間"
                onClick={scrollByOffset}
                offset={offset}
              >
                データセットの対象期間
              </CssLink>
            )}
            {dataSetIds.ids !== "" && (
              <CssLink
                activeClass="clsLinkActive"
                smooth
                spy
                to="前処理方法"
                onClick={scrollByOffset}
                offset={offset}
              >
                前処理方法
              </CssLink>
            )}
            {dataSetIds.ids !== "" && (
              <CssLink
                activeClass="clsLinkActive"
                smooth
                spy
                to="生データのファイル形式・アクセス権・提供頻度等に関する情報"
                onClick={scrollByOffset}
                offset={offset}
              >
                生データのファイル形式・アクセス権・提供頻度等に関する情報
              </CssLink>
            )}
            <CssLinkTitle
              activeClass="clsLinkActive"
              smooth
              spy
              to="本データに関して"
              onClick={scrollByOffset}
              offset={offset}
            >
              本データに関して
            </CssLinkTitle>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="データ利用条件"
              onClick={scrollByOffset}
              offset={offset}
            >
              データ利用条件
            </CssLink>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="データ保護要件"
              onClick={scrollByOffset}
              offset={offset}
            >
              データ保護要件
            </CssLink>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="データ価格"
              onClick={scrollByOffset}
              offset={offset}
            >
              データ価格
            </CssLink>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="契約ポリシー"
              onClick={scrollByOffset}
              offset={offset}
            >
              契約ポリシー
            </CssLink>
            <CssLinkTitle
              activeClass="clsLinkActive"
              smooth
              spy
              to="データに関する問い合わせ先"
              onClick={scrollByOffset}
              offset={offset}
            >
              データに関する問い合わせ先
            </CssLinkTitle>
          </Box>
        </Box>
        <section id={"データジャケット情報"}>
          <CardTitle title={"データジャケット情報"} />
        </section>
        <CssBox>
          <GeneralAccordionCard
            key={"データの収集方法"}
            title={"データの収集方法"}
            contents={[
              {
                subcontent: dataJacket.data_jacket_collection,
              },
            ]}
            accordion={true}
          />
        </CssBox>
        <CssBox>
          <GeneralAccordionCard
            key={"データセットの分析方法・ケースおよび結果概要"}
            title={"データセットの分析方法・ケースおよび結果概要"}
            contents={[
              {
                subcontent: dataJacket.dataset_analysis,
                subcontent2: dataJacket.analysis_results,
                subcontent3: dataJacket.analysis_results_other,
              },
            ]}
            titleFirst={"データセットの分析方法"}
            titleSecond={"分析ケースおよび結果概要"}
            titlethird={"その他に期待する分析方法と結果"}
            accordion={true}
          />
        </CssBox>
        <CssBox>
          <GeneralAccordionCard
            key={"自由記述"}
            title={"自由記述"}
            contents={[
              {
                subcontent: dataJacket.data_jacket_free_text,
              },
            ]}
            accordion={false}
          />
        </CssBox>
        <CssBox>
          <GeneralAccordionCard
            key={"データジャケットのライセンス"}
            title={"データジャケットのライセンス"}
            contents={[
              {
                subcontent: dataJacket.data_jacket_license,
              },
            ]}
            accordion={false}
          />
        </CssBox>
        <CssBox>
          <GeneralAccordionCard
            key={"データジャケットの権利表明"}
            title={"データジャケットの権利表明"}
            contents={[
              {
                subcontent: dataJacket.data_jacket_right,
              },
            ]}
            accordion={false}
          />
        </CssBox>
        <CssBox>
          <GeneralAccordionCard
            key={"データジャケットの公開等に関する情報"}
            title={"データジャケットの公開等に関する情報"}
            contents={[
              {
                subcontent: "公開可否　　　　：",
                subchildcontent: dataJacket.data_jacket_public,
              },
              {
                subcontent: "公開範囲　　　　：",
                subchildcontent: dataJacket.data_jacket_scope,
              },
              {
                subcontent: "有償／無償　　　：",
                subchildcontent: dataJacket.data_jacket_price,
              },
              {
                subcontent: "公開者　　　　　：",
                subchildcontent: dataJacket.data_jacket_publisher,
              },
              {
                subcontent: "出典　　　　　　：",
                subchildcontent: dataJacket.data_jacket_source,
              },
              {
                subcontent: "関連ホームページ：",
                subchild: "Link",
                subchildcontent: dataJacket.data_jacket_homepage,
              },
            ]}
            accordion={false}
          />
        </CssBox>
        <section id={"データセット情報"}>
          <CardTitle title={"データセット情報"} />
        </section>
        <CssBox>
          {dataSetIds.ids !== "" ? (
            <Card6
              titleName={"データセットのタイトル"}
              items={dataSetIds}
            ></Card6>
          ) : (
            <CssDataJacketBodyTypography
              style={{
                color: "white",
                fontSize: "16px",
                marginLeft: "12px",
              }}
            >
              データセット未登録
            </CssDataJacketBodyTypography>
          )}
        </CssBox>
        <section id={"本データに関して"}>
          <CardTitle title={"本データに関して"} />
        </section>
        <CssBox>
          <GeneralAccordionCard
            key={"データ利用条件"}
            title={"データ利用条件"}
            contents={[
              {
                subcontent: "データの類別　　　：",
                subchildcontent: termOfUse.data_rules,
              },
              {
                subcontent: "情報管理区分　　　：",
                subchildcontent: termOfUse.information_management_category,
              },
              {
                subcontent: "派生データの利用権：",
                subchildcontent: termOfUse.derived_data_right,
              },
              {
                subcontent: "データの有効期間　：",
                subchildcontent:
                  convertDateTimeToDate(
                    termOfUse.data_validity_start === undefined
                      ? ""
                      : termOfUse.data_validity_start
                  ) +
                  " - " +
                  convertDateTimeToDate(
                    termOfUse.data_validity_end === undefined
                      ? ""
                      : termOfUse.data_validity_end
                  ),
              },
              {
                subcontent: "第三者への開示要件：",
                subchildcontent: termOfUse.third_party_disclosure_requirement,
              },
              {
                subcontent: "データ購入者の制限：",
                subchildcontent: termOfUse.data_buyer_restriciting,
              },
              {
                subcontent: "注意事項　　　　　：",
                subchildcontent: termOfUse.caution,
              },
            ]}
            accordion={false}
          />
        </CssBox>
        <CssBox>
          <GeneralAccordionCard
            key={"データ保護要件"}
            title={"データ保護要件"}
            contents={[
              {
                subcontent: "データ管理要件　　　　　：",
                subchildcontent: protection.data_management_requirement,
              },
              {
                subcontent: "データ利用者に求める資格：",
                subchildcontent: protection.qualification_required,
              },
            ]}
            accordion={false}
          />
        </CssBox>
        <CssBox>
          <GeneralAccordionCard
            key={"データ価格"}
            title={"データ価格"}
            contents={[
              {
                subcontent: "請求類型　　　　　　　　　：",
                subchildcontent: price.claim_type,
              },
              {
                subcontent: "価格帯　　　　　　　　　　：",
                subchildcontent: price.price_range,
              },
              {
                subcontent: "課金単位　　　　　　　　　：",
                subchildcontent: price.billing_unit,
              },
              {
                subcontent: "請求頻度　　　　　　　　　：",
                subchildcontent: price.billing_frequency,
              },
              {
                subcontent: "データ販売に関する特記事項：",
                subchildcontent: price.special_notes_data_sale,
              },
            ]}
            accordion={false}
          />
        </CssBox>
        <CssBox>
          <GeneralAccordionCard
            key={"契約ポリシー"}
            title={"契約ポリシー"}
            contents={[
              {
                subcontent: "契約形態：",
                subchildcontent:
                  policy.form_of_contract === undefined
                    ? ""
                    : policy.form_of_contract,
              },
              {
                subcontent: "利用用途：",
                subchildcontent:
                  policy.intended_use === undefined ? "" : policy.intended_use,
              },
            ]}
            accordion={false}
          />
        </CssBox>
        <CardTitle title={"データに関する問い合わせ先"} />
        <section id="データに関する問い合わせ先">
          <CssBox>
            <CardContact
              organization={dataJacket.data_jacket_counter_organization}
              department={dataJacket.data_jacket_counter_department}
            />
          </CssBox>
        </section>
      </div>
    </span>
  );
}
